export const IssueAiStatus = Object.freeze({
  /** 未分析 */
  NONE: 0,
  /** 已在线分析 */
  USER_GENERATED: 1,
  /** 已离线分析 */
  SYSTEM_GENERATED: 2,
});

/** t_ai_analyse_result.analysis_type。未知值按 Dify 渲染。用户可见标签仍是 CrashSight问题分析。 */
export const AiAnalysisType = Object.freeze({
  DIFY: 'dify',
  CRASHCLAW: 'crashclaw',
  isCrashClaw(type) {
    return type === 'crashclaw';
  },
});
